import { Injectable } from '@angular/core';

declare const posthog: any;

@Injectable({ providedIn: 'root' })
export class PosthogService {
  private get ph(): any {
    return typeof posthog !== 'undefined' ? posthog : null;
  }

  identify(userId: string, properties?: Record<string, any>): void {
    this.ph?.identify(userId, properties);
  }

  capture(event: string, properties?: Record<string, any>): void {
    this.ph?.capture(event, properties);
  }

  pageview(url: string): void {
    this.ph?.capture('$pageview', { $current_url: url });
  }

  reset(): void {
    this.ph?.reset();
  }
}
